import { render, staticRenderFns } from "./detail-content.vue?vue&type=template&id=7f6a80ca&scoped=true"
import script from "./detail-content.vue?vue&type=script&lang=js"
export * from "./detail-content.vue?vue&type=script&lang=js"
import style0 from "./detail-content.vue?vue&type=style&index=0&id=7f6a80ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a80ca",
  null
  
)

export default component.exports